<template>
  <transition-group class="tips-container" name="list">
    <div v-for="(item, index) in $store.state.alert_msg_arr" :key="item"  >
      <AlertItem
        :msg="item"
        :dataIndex="index"
      />
    </div>
  </transition-group>
</template>

<script>
import AlertItem from './alert_item'
export default {
  name: 'ShowAlert',
  components: {
    AlertItem
  }
}
</script>

<style lang="less" scoped>
.list-enter-active, .list-leave-active {
  transition: all .2s;
}
.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.tips-container {
  width: 500px;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  top: 15%;
  z-index: 1111;
}
</style>



// WEBPACK FOOTER //
// src/components/common/show_alert.vue